import { Stack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { CustomerDetailTypes } from '../..';

import { CompositionChart } from './components/CompositionChart';
import { PortfolioProfitability } from './components/PortfolioProfitability';
import { ProfitabilityChart } from './components/ProfitabilityChart';
import { SentOrders } from './components/SentOrders';

export const Summary: React.FC<CustomerDetailTypes.Props> = ({ changeSelectedTab }) => {
  const handleGoToFinancialDetails = (financialDetailsInitialTab?: string) => {
    changeSelectedTab('posicao-detalhada', { financialDetailsInitialTab });
  };

  return (
    <VStack space={Spacing['stack.xxs']}>
      <Stack space={Spacing['stack.xxs']} direction={{ base: 'column', lg: 'row' }}>
        <CompositionChart handleGoToFinancialDetails={handleGoToFinancialDetails} />
        <ProfitabilityChart />
      </Stack>
      <VStack space={Spacing['stack.xxs']}>
        <PortfolioProfitability />
        <SentOrders />
      </VStack>
    </VStack>
  );
};
